import React from "react";

/**
 * ItemsList Component
 * Renders an elegant list of items with labels and optional prices
 */
const ItemsList = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="structured-section structured-list">
      <ul className="structured-list-items">
        {items.map((item, index) => (
          <li key={index} className="structured-list-item">
            <div className="list-item-content">
              <span className="list-item-number">{index + 1}</span>
              <span className="list-item-label">{item.label}</span>
            </div>
            {item.price !== undefined && item.price !== null && item.price !== 0 && (
              <span className="structured-list-price">₹{item.price}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ItemsList;
